import React from 'react';
import {Box, Typography, Checkbox, FormControlLabel, LinearProgress, useTheme, useMediaQuery} from '@mui/material';
import PurpleButton from '../common/buttonTheme';
import MoveArrow from './MoveArrow';
import LocalDate from '../common/convert_to_local';
import SimpleAlert from '../common/alert_message';
import {Accordion, AccordionSummary, AccordionDetails} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const TodoItem = ({ 
  todo,
  todos,
  index,
  handleDone,
  handleEdit,
  onDelete,
  changeorder,
  handleOpenView,
  handleOpenAssistant}) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box 
          display="flex" 
          flexDirection="column" 
          width="100%" 
          boxShadow={6} 
          padding={3} 
          key={`b1`+ todo.id}
          sx={{ 
            width: '100%',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
            
         <Typography
                    variant="h6" 
                    padding={2}
                    style={{ color: todo.isDone ? "green" : "", width: '100%' }}
                    key={`title`+ todo.id}> {todo.listName ? `${todo.listName} / ` : ""} {todo.title} {todo.dateTimeToDoToDo ? <> | Due: <LocalDate utcDate={todo.dateTimeToDoToDo} /></> : ""}</Typography>  
                    <LinearProgress variant="determinate" value={todo.percentDone} style={{ width: '100%' }} />
          <Accordion key={`acc_${index}`} sx={{ width: '100%' }}>
            <AccordionSummary
                key={`accsumm_${todo.id}`}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header" >
                 <Typography
                    variant="body1" 
                    style={{whiteSpace: "pre-line", paddingLeft: 20}}
                    key={"sig_" + todo.id} >
                    Details
                </Typography>
            </AccordionSummary>
            <AccordionDetails key={`accdet_${todo.id}`} sx={{ width: '100%' }}>

            <Typography
                    variant="body1" 
                    gutterBottom
                    style={{whiteSpace: "pre-line", width: '100%'}}
                    key={"Description_" + todo.id} >{todo.description}</Typography>
                    
                    {todo.dateDone_utc ? <p> <SimpleAlert textMessage={<LocalDate text="Date completed - " utcDate={todo.dateDone_utc} />}/> </p> : ""}

                    
            </AccordionDetails>
      </Accordion>
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        gap={1}
        alignItems={isMobile ? "stretch" : "center"}
        width="100%"
        key={`b2`+ todo.id}
        justifyContent="flex-end"
        sx={{ whiteSpace: "pre-line", paddingTop: 2 }}
      >
        <FormControlLabel
          key={`fcl`+ todo.id}
          control={
            <Checkbox
              onClick={() => handleDone(todo.id)}
              checked={todo.isDone}
              id={todo.id}
              key={`isDone`+ todo.id}
            />
          }
          label={todo.isDone ? "Uncheck to mark as not done" : "Mark as done"}
          sx={{ marginRight: isMobile ? 0 : 2 }}
        />

        <Box
          display="flex"
          flexDirection={isMobile ? "column" : "row"}
          gap={1}
          width={isMobile ? "100%" : "auto"}
        >
          {index + 1 < todos.length && (
            <MoveArrow
              handleClick={()=>{changeorder(todo.id,1)}}
              action="down"
              key={`down`+ todo.id}
            />
          )}
          {index !== 0 && (
            <MoveArrow
              id={todo.id}
              handleClick={()=>{changeorder(todo.id, -1)}}
              action="up"
              key={`up`+ todo.id}
            />
          )}

          <PurpleButton
            onClick={() => handleOpenView(todo)}
            variant="contained"
            key={`view`+ todo.id}
            fullWidth={isMobile}
            sx={{ marginLeft: isMobile ? 0 : 1 }}
          >
            View
          </PurpleButton>

          <PurpleButton
            onClick={() => handleEdit(todo.id)}
            variant="contained"
            key={`edit`+ todo.id}
            fullWidth={isMobile}
            sx={{ marginLeft: isMobile ? 0 : 1 }}
          >
            Edit
          </PurpleButton>

          <PurpleButton
            onClick={() => onDelete(todo.id)}
            variant="contained"
            key={`delete_`+ todo.id}
            fullWidth={isMobile}
            sx={{ marginLeft: isMobile ? 0 : 1 }}
          >
            Delete
          </PurpleButton>
        </Box>
      </Box>
          
                    
                  </Box>
    )
}

export default TodoItem;